// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { sharedCarouselStyles } from "@eisinc/App/SharedStyles/ProductCarouselStyles";
import { purchasedProductsStyles } from "@eisinc/Overrides/Widgets/Common/PurchasedProducts";
import { color, xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

purchasedProductsStyles.miniCardStyles = {
    ...sharedCarouselStyles.miniCardStyles,
};

purchasedProductsStyles.carouselProductCondensedStyles = {
    ...sharedCarouselStyles.carouselProductCondensedStyles,
};

purchasedProductsStyles.carouselProductStyles = {
    ...sharedCarouselStyles.carouselProductStyles,
};
purchasedProductsStyles.borderSeparator = {
    css: css`
        border-bottom: 3px solid ${color("common.ui7")};
        ${({ carouselTemplate }: any) =>
            carouselTemplate &&
            css`
                margin-bottom: 16px;
            `}
    `,
};
purchasedProductsStyles.titleText = {
    variant: "h2",
};
purchasedProductsStyles.headerContainer = {
    css: css`
        padding: 10px;
        background-color: ${color("common.ui2")};
        display: grid;
        grid-template-columns: 85px minmax(280px, 1fr) minmax(0, 162px) minmax(0, 140px) 162px;
        gap: 8px 16px;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
purchasedProductsStyles.productDescriptionHeaderGridItem = {
    css: css``,
};

purchasedProductsStyles.priceHeaderGridItem = {
    css: css`
    `,
};
purchasedProductsStyles.availabilityHeaderGridItem = {
    css: css`
    `,
};
purchasedProductsStyles.availabilityHeaderText = { weight: "bold" };
purchasedProductsStyles.addToCartHeaderGridItem = {
    css: css``,
};
purchasedProductsStyles.scrollProductsContainer = {
    css: css`
        overflow-x: auto;
        width: 100%;
    `,
};